import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../features/modal/ModalSlice";

const EditMember = () => {
  const dispatch = useDispatch();

  const handleClosePopup = () => {
    dispatch(closeModal());
  };
  return (
    <div className={"rightModal taskModal"}>
      <div className="modal-header p-3">
        <h4 className="m-0">Edit Member</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4"></div>
    </div>
  );
};

export default EditMember;
